<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-overlay :value="loading" style="text-align:center; z-index: 99999;">
        <v-card width="450px" height="150px" class="pa-3" color="white" style="opacity: 80%;">
          <v-progress-circular indeterminate size="64" color="#00B500"></v-progress-circular>
          <p style="font-weight: 600; font-size: 18px; line-height: 24px; color: #333333; margin-top: 30px;">กำลังนำเข้าข้อมูล กรุณารอสักครู่</p>
        </v-card>
      </v-overlay>
      <v-card elevation="0" width="100%" height="100%">
        <v-card-title class="px-0 pb-0" style="font-weight: bold;  font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">
          <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> ข้อมูลนำเข้า
          <span>
            <v-chip small class="ma-2" :color="status === 'success' ? '#F0F9EE' : '#F7D9D9'" :text-color="status === 'success' ? '#1AB759' : '#F5222D'" style="font-weight: normal">{{ status === 'success' ? 'นำเข้าข้อมูลสำเร็จ' : 'นำเข้าข้อมูลไม่สำเร็จ'}}</v-chip>
          </span>
        </v-card-title>
        <v-card-title class="px-0 pb-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
          <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> ข้อมูลนำเข้า
          <span>
            <v-chip small class="ma-2" :color="status === 'success' ? '#F0F9EE' : '#F7D9D9'" :text-color="status === 'success' ? '#1AB759' : '#F5222D'" style="font-weight: normal">{{ status === 'success' ? 'นำเข้าข้อมูลสำเร็จ' : 'นำเข้าข้อมูลไม่สำเร็จ'}}</v-chip>
        </span>
        </v-card-title>
      </v-card>
      <v-card-text class="pt-0">
        <v-row no-gutters>
          <v-row :class="MobileSize || IpadSize || IpadProSize ? 'mt-1' : 'my-3'">
            <v-col cols="12" class="pt-2 pb-0" align="end">
              <v-btn v-if="status === 'fail'" width="103" class="ml-1 mt-2 mr-2" color="#27AB9C" dark outlined @click="$refs.file_input.click()">
                <v-icon small>mdi-file-upload-outline</v-icon>นำเข้าข้อมูล
              </v-btn>
              <input type="file" @click="event => event.target.value = null" @change="previewFiles($event)" ref="file_input" accept=".xls, .xlsx" style="display: none;"/>
            </v-col>
            <v-col cols="12" class="pt-3 pb-0">
              <v-row dense>
                <v-col :cols="12" class="pt-2">
                  <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">รายการเพิ่มข้อมูลสินค้าทั้งหมด {{ showCountImportProduct }} รายการ</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-col cols="12" v-if="disableTable === false">
            <v-data-table
            :headers="headers"
            :items="importProductList"
            style="width:100%;"
            height="100%"
            :page.sync="page"
            @pagination="countCustomer"
            no-results-text="ไม่พบรายการสินค้า"
            no-data-text="ไม่มีรายการสินค้าในตาราง"
            :footer-props="{'items-per-page-text':'จำนวนแถว'}"
            @update:items-per-page="itemsPerPage"
            :items-per-page="10"
            class="elevation-1 mt-4"
            >
              <template v-slot:[`item.number`]="{ item }">
                <span>{{importProductList.indexOf(item) + 1}}</span>
              </template>
              <template v-slot:[`item.note`]="{ item }">
                <span v-if="item.note === '-'">{{ item.note }}</span>
                <span v-else style="color: #F5222D;">{{ item.note }}</span>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" v-else>
            <v-row justify="center" align-content="center">
              <v-col cols="12" md="12" align="center">
                <div class="my-5">
                  <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
                </div>
                <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายการสินค้า</b></h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { Decode, Encode } from '@/services'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  data () {
    return {
      seller_shop_id: '',
      loading: false,
      status: '',
      importProductList: '',
      disableTable: false,
      showCountImportProduct: 0,
      headers: [
        { text: 'ที่', value: 'number', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'SKU', value: 'sku', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'หน่วยนับที่ 1', value: 'attribute_1', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาหน่วยนับที่ 1', value: 'attribute_1_price', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'หน่วยนับที่ 2', value: 'attribute_2', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาหน่วยนับที่ 2', value: 'attribute_2_price', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'หน่วยนับที่ 3', value: 'attribute_3', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาหน่วยนับที่ 3', value: 'attribute_3_price', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'หน่วยนับที่ 4', value: 'attribute_4', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาหน่วยนับที่ 4', value: 'attribute_4_price', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'หน่วยนับที่ 5', value: 'attribute_5', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคาหน่วยนับที่ 5', value: 'attribute_5_price', sortable: false, width: '119px', class: 'backgroundTable fontTable--text' },
        { text: 'การตรวจสอบข้อมูล', value: 'note', sortable: false, width: '128px', class: 'backgroundTable fontTable--text' }
      ]
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        var userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        this.seller_shop_id = userDetailSelling
      }
      this.loading = false
      this.getData()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push('/Order/ProductListMobile').catch(() => {})
      } else {
        this.$router.push('/Order/ProductList').catch(() => {})
      }
    },
    getData () {
      if (localStorage.getItem('previewCheckImportProduct') !== undefined && localStorage.getItem('previewCheckImportProduct') !== null) {
        var previewCheckImportProduct = JSON.parse(Decode.decode(localStorage.getItem('previewCheckImportProduct')))
        this.importProductList = previewCheckImportProduct.data
        this.showCountImportProduct = this.importProductList.length
        if (previewCheckImportProduct.response === 'Fail To Import Product Price.') {
          this.status = 'fail'
        } else if (previewCheckImportProduct.response === 'Import Product Price Success.') {
          this.status = 'success'
        }
        if (this.importProductList.length !== 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      }
    },

    // import file
    previewFiles (e) {
      var files = e.target.files
      console.log(files)
      var f = files[0]
      // var dataJ
      var reader = new FileReader()
      reader.onload = (e) => {
        var data = new Uint8Array(e.target.result)
        console.log(data)
        var workbook = XLSX.read(data, { type: 'array' })
        console.log(workbook)
        const sheetName = workbook.SheetNames[0]
        /* DO SOMETHING WITH workbook HERE */
        const worksheet = workbook.Sheets[sheetName]
        console.log(worksheet)
        console.log(XLSX.utils.sheet_to_json(worksheet))
        this.importCustomerData(XLSX.utils.sheet_to_json(worksheet))
      }
      reader.readAsArrayBuffer(f)
    },
    async importCustomerData (excelJson) {
      this.loading = true
      var sendData
      const data = {
        seller_shop_id: this.seller_shop_id,
        file: excelJson,
        staus: 'preview'
      }
      await this.$store.dispatch('actionsGraczImportProduct', data)
      var response = await this.$store.state.ModuleGraczAdmin.stateGraczImportProduct
      if (response.code !== 500) {
        if (response.message === 'Import Product Price Success.') {
          this.loading = false
          this.$swal.fire({ icon: 'success', text: 'นำเข้าข้อมูลสินค้าจากไฟล์ Excel สำเร็จ', showConfirmButton: false, timer: 2000 })
          sendData = { response: response.message, data: response.data }
          localStorage.setItem('previewCheckImportProduct', Encode.encode(sendData))
        } else {
          this.loading = false
          if (response.message === 'Fail To Import Product Price.') {
            this.$swal.fire({ icon: 'warning', text: 'ไม่สามารถนำเข้าข้อมูลสินค้าจากไฟล์ Excel ได้ (ข้อมูลในไฟล์มีข้อผิดพลาด)', showConfirmButton: false, timer: 2000 })
            sendData = { response: response.message, data: response.data }
            console.log(sendData)
            localStorage.setItem('previewCheckImportProduct', Encode.encode(sendData))
          } else if (response.message === 'This user is unauthorized.') {
            this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else if (response.message === 'Not access this function.') {
            this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else {
            var [msg, iconMsg] = this.getErrorMsg(response.message)
            this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
          }
        }
      } else {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'ไม่สามารถนำเข้าข้อมูลสินค้าจากไฟล์ Excel ได้ (ข้อมูลในไฟล์มีข้อผิดพลาด)', showConfirmButton: false, timer: 2000 })
      }
      this.getData()
    }
  }

}
</script>

<style>
</style>
<style lang="scss" scoped>
  ::v-deep table {
    tbody {
      tr {
        td:nth-child(13) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(1) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(13) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 11;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
</style>
